import { render } from "./ModuleBoardDecisions.vue?vue&type=template&id=11072e86&scoped=true"
import script from "./ModuleBoardDecisions.vue?vue&type=script&lang=js"
export * from "./ModuleBoardDecisions.vue?vue&type=script&lang=js"

import "./ModuleBoardDecisions.vue?vue&type=style&index=0&id=11072e86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11072e86"]])

export default __exports__